import { FC, useCallback } from 'react';
import { ClickPosition } from '~/utils/click-position';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $CurrentArticleAsAvailable } from '@article/shared/atoms/current-article';
import { Link } from '@remix-run/react';
import { $CurrentArticleTranslated } from '@article/shared/atoms/current-article-translated';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useSEOHref } from '~/utils/build-seo-url';
import { ArticleDetailUtil } from 'shared/models';

import './style.scss';

export const OriginalPostBanner: FC = () => {
  const { t } = useTranslation();
  const currentArticleTranslated = useAtomValue($CurrentArticleTranslated);
  const { isBot } = useAtomValue($UserAgent);

  const article = useAtomValue($CurrentArticleAsAvailable);

  const originArticleHref = useSEOHref(ArticleDetailUtil.getArticleHref(article));

  const handleBannerClick = useCallback(() => {
    window.Tea('wap_click', {
      current_position: ClickPosition.original_post_banner,
      is_cta: 1,
    });
  }, []);

  if (!currentArticleTranslated || isBot) {
    return null;
  }

  return (
    <div className="original-post-banner">
      <p className="original-post-banner-text">
        {t('seo_banner_desc_autoTranslated_eng')}
        <Link to={originArticleHref} target="_blank" className="original-post-banner-link" onClick={handleBannerClick}>
          {t('seo_banner_btn_view_originalPost')}
        </Link>
      </p>
    </div>
  );
};
